module.exports = __webpack_public_path__ + "assets/img/opzm_logo.e491b27e.jpg";